// extracted by mini-css-extract-plugin
export default {"Page":"Faq_Page__Q5BTL","PageContent":"Faq_PageContent__frtqQ","PageTitle":"Faq_PageTitle__V51yJ"};